function ZoneVertex(aZoneId, aLatitude, aLongitude, aOrderIndex) {
    "use strict";

    this.__type = 'ZoneVertex:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.IsActive = true;
    this.IsLast = false;
    this.Latitude = RoundNumber(aLatitude, 7);
    this.Longitude = RoundNumber(aLongitude, 7);
    this.OrderIndex = aOrderIndex;
    this.ZoneId = aZoneId;
    this.TransactionId = moment().format("YYYYMMDDHHmmss");
    
}
if (typeof exports !== 'undefined') {
    module.exports = ZoneVertex;
}